// Copyright (c) 2017 Deere & Company

import ClaimForApproval from '@deere/cps-it.warranty-model-factory/lib/claim-for-approval';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import actions from '../../actions-list';
import {getDefaultState as getSpaDetailsDefaultState} from '../state';

const updateSpaClaim = (state, action) =>
    ClaimForApproval.update(state, {
        $set: action.data
    });

const updateCustomContribution = (state, action) => {

    const updatedState = ClaimForApproval.update(state, {
        contributions: {
            custom: {
                [action.property]: {
                    $set: action.value
                }
            }
        }
    });

    return ClaimForApproval.update(updatedState, {
        contributions: {
            custom: {
                total: {
                    $set: updatedState.contributions.custom.calculateTotal()
                }
            }
        }
    });

};

const updateCommentsToDealer = (state, action) =>
    ClaimForApproval.update(state, {
        commentsToDealer: {
            $set: action.data
        }
    });

const updateInternalDeereComments = (state, action) =>
    ClaimForApproval.update(state, {
        internalDeereComments: {
            $set: action.data
        }
    });

const updateSelectedContribution = (state, action) =>
    ClaimForApproval.update(state, {
        contributions: {
            selectedContribution: {
                $set: new KeyValuePair({
                    key: action.data,
                    value: action.data
                })
            }
        }
    });

const setStatus = (state, action) =>
    ClaimForApproval.update(state, {
        status: {
            $set: new KeyValuePair({
                key: action.data,
                value: action.data
            })
        }
    });

const updateSpaType = (state, action) =>
    ClaimForApproval.update(state, {
        specialAllowanceType: {
            $set: action.data
        }
    });

const resetSpaClaim = () =>
    getSpaDetailsDefaultState().claim;

export default (state = getSpaDetailsDefaultState().claim, action) => {

    const actionTypes = {
        [actions.RESET_TABM_SPA_CLAIM_DETAILS]: resetSpaClaim,
        [actions.UPDATE_TABM_SPA_CLAIM_STATUS]: setStatus,
        [actions.UPDATE_TABM_SPA_CLAIM_COMMENTS_TO_DEALER]: updateCommentsToDealer,
        [actions.UPDATE_TABM_SPA_CLAIM_CONTRIBUTION]: updateCustomContribution,
        [actions.UPDATE_TABM_SPA_CLAIM_DETAILS]: updateSpaClaim,
        [actions.UPDATE_TABM_SPA_CLAIM_INTERNAL_DEERE_COMMENTS]: updateInternalDeereComments,
        [actions.UPDATE_TABM_SPA_CLAIM_SELECTED_CONTRIBUTION]: updateSelectedContribution,
        [actions.UPDATE_TABM_SPA_TYPE]: updateSpaType
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tabm/spa-details/reducers/claim.js